import { z } from 'zod';
import { inferApiResultSchema } from './infer-api';

export const VoteSchema = z.object({
  id: z.number(),
  accountId: z.string().max(50),
  userId: z.string().nullable(),
  contactId: z.number().nullable(),
  ideaId: z.number(),
});

export type VoteDto = z.infer<typeof VoteSchema>;

export const GetVoteCountByIdeaResponseSchema = inferApiResultSchema(
  z.object({
    count: z.number(),
  }),
);
export type GetVoteCountByIdeaResponseDto = z.infer<typeof GetVoteCountByIdeaResponseSchema>;

export const UserHasVotedOnIdeaResponseSchema = inferApiResultSchema(
  z.object({
    hasVoted: z.boolean(),
  }),
);
export type UserHasVotedOnIdeaResponseDto = z.infer<typeof UserHasVotedOnIdeaResponseSchema>;

export const CreateVoteResponseSchema = inferApiResultSchema(VoteSchema);
export type CreateVoteReponseDto = z.infer<typeof CreateVoteResponseSchema>;
